import { Img } from '@/components/Img.tsx';
import { Layout } from '@/components/Layout.tsx';
import { TEAM_MEMBERS } from '@/data/content.ts';
import { asset } from '@/lib/paths.ts';

export function About() {
  return (
    <Layout currentPath="/about" navOnLight={true}>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero__image-wrap">
          <Img
            src="images/hero-about.webp"
            alt="Educators and researchers collaborating with laptops"
            width={1376}
            height={768}
            priority
            className="about-hero__image"
          />
        </div>
        <div className="about-hero__overlay" aria-hidden="true" />
        <div className="container about-hero__content">
          <h1>Built by educators, for educators</h1>
          <p className="about-hero__lede">
            LearnAI was born from a simple question: what if AI could make
            students think harder, not less?
          </p>
        </div>
      </section>

      {/* Story / Mission Section */}
      <section className="about-story">
        <div className="container container--narrow">
          <div className="about-story__content fade-in">
            <p>
              In the 1970s, parents feared calculators would make students
              forget basic math. Instead, calculators freed us to tackle harder
              problems. AI is education&apos;s next calculator moment.
            </p>
            <p>
              LearnAI was founded on the belief that AI should amplify teaching,
              not replace it. Our platform keeps teachers in the driver&apos;s
              seat while giving every student the personalized attention that
              research proves works best.
            </p>
            <p>
              We&apos;re a team of educators, researchers, and builders working
              with school districts and universities to prove that AI &mdash;
              done right &mdash; improves learning outcomes.
            </p>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section className="about-team">
        <div className="container">
          <h2 className="fade-in">Our Team</h2>
          <ul className="team-grid">
            {TEAM_MEMBERS.map((member) => (
              <li key={member.name} className="fade-in">
                <div className="team-member">
                  <div
                    className={`team-member__photo${member.image ? '' : ' team-member__photo--placeholder'}`}
                    aria-hidden={member.image ? undefined : 'true'}
                  >
                    {member.image ? (
                      <img
                        src={asset(member.image)}
                        alt={member.name}
                        width={150}
                        height={150}
                        loading="lazy"
                      />
                    ) : (
                      <span>{member.initials}</span>
                    )}
                  </div>
                  <h4>{member.name}</h4>
                  <div className="team-member__title">{member.role}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Backed By Research Section */}
      <section className="about-research">
        <div className="container">
          <div className="about-research__content fade-in">
            <h2>Backed By Research</h2>
            <p>
              Our approach isn&apos;t a guess. It&apos;s grounded in decades of
              education research.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
